export default __webpack_public_path__ + "static/media/panTech2Full.22745df5.png";